import { useAppSelector } from 'shared/store';
import { selectActiveUser } from 'shared/store/shared-selectors';
import { Gateway, SelfUser } from 'types';

export function useIsGatewayActivated(gateway: Gateway) {
  const user = useAppSelector(selectActiveUser);
  return isGatewayActive(gateway, user);
}

export function isGatewayActive(gateway: Gateway, user: null | SelfUser): boolean {
  return (user && user.gateways[gateway]) || false;
}
